import { cn } from "@utils/tw"

export const TabButton = ({
  children,
  className,
  onClick,
}: {
  children: React.ReactNode
  className?: string
  onClick?: () => void
}) => {
  return (
    <button
      className={cn("p-3 rounded-md text-sm whitespace-nowrap bg-charcoal/20 text-offWhite", className)}
      onClick={() => onClick?.()}
    >
      {children}
    </button>
  )
}
